export default __webpack_public_path__ + "static/media/Kiddiepreneur101.bdbd2c16.png";